export default __webpack_public_path__ + "static/media/loading_spinner.d2b78842.gif";